<template>
  <div class="salesCommission">
    <div class="title-box">
      <h3 class="pull-left">{{salesCommissionLan.saleAccount}} : {{$route.query.id}}<span v-if="showPreview"> - {{salesCommissionLan.btnGroup.commissionPreviewBtn}}</span></h3>
      <div class="pull-right viewBtn-box" v-if="!showPreview">
        <button class="double" @click="viewBtn = 'double'" >
          <span class="glyphicon glyphicon-list-alt"></span><span class="glyphicon glyphicon-list-alt"></span>
          {{salesCommissionLan.contrastBrowse}}
        </button>
        <button @click="viewBtn = 'onlyOne'" >
          <span class="glyphicon glyphicon-list-alt"></span>
          {{salesCommissionLan.singlepageBrowse}}
        </button>
      </div>
      <button class="pull-right preview-btn" @click="showPreview = true" v-if="!showPreview">
          {{salesCommissionLan.btnGroup.commissionPreviewBtn}}
      </button>
      <button class="pull-right preview-btn" @click="showPreview = false" v-else>
          {{salesCommissionLan.btnGroup.back}}
      </button>
      <div class="clear"></div>
    </div>
    <div class="content-box" v-if="showPreview">
      <sale-commission-preview :region="curArea" :multiLanguage="salesCommissionLan" :reqData="reqData"></sale-commission-preview> 
    </div>
    <div class="content-box" v-if="!showPreview">
      <div class="version0" :class="{'doubleView margin-right' : viewBtn === 'double'}" v-if="viewBtn=='double'">
        <sale-commission-content
          :multiLanguage="salesCommissionLan"
          :version="'0'" 
          :viewBtn="viewBtn"
          :curArea="curArea"
          ref="version0"
        >
        </sale-commission-content>
      </div>
      <div class="version1" :class="{'doubleView' : viewBtn === 'double'}">
        <sale-commission-content
          :multiLanguage="salesCommissionLan"
          :version="'1'" 
          :viewBtn="viewBtn"
          :curArea="curArea"
          ref="version1"
          @afterVerify="afterVerifyFn"
        >
        </sale-commission-content>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import saleCommissionPreview from './saleCommissionPreview'
import saleCommissionContent  from './saleCommissionContent'

export default {
  name: 'salesCommissionSetting',
  props:['curArea'],
  mixins: [
    require("common/mixin/base.js").base({salesCommissionLan:"salesCommission"}),
  ],
  data () {
    return {
      showPreview: false,
      viewBtn: 'onlyOne',
      reqData: null
    }
  },
  components: {
    saleCommissionPreview,
    saleCommissionContent
  },
  methods: {
    afterVerifyFn () { // 审核成功后 再次刷新version0
      this.$refs.version0 && this.$refs.version0.pageInit('0')
    }
  }
}
</script>

<style lang="scss" scoped>
.salesCommission{
  margin-top: 20px;
  padding-bottom: 20px;
  .title-box{
    border: 1px solid #3F51B5;
    margin: 0 20px;
    background: #3F51B5;
    padding: 0 20px;
    color: #fff;
    border-radius: 5px 5px 0 0;
    .preview-btn{
        margin-top: 12px;
        border: 1px solid #F08712;
        background-color: #F08712;
        height: 40px;
        padding: 0 10px;
        border-radius: 5px;
    }
    .viewBtn-box{
      margin: 12px 0 0 20px;
      line-height: 40px;
      height: 40px;
      box-sizing: border-box;
      text-align: right;
      span{
        font-size: 12px;
        font-weight: 700;
        color: #fff;
      }
      button{
        height: 40px;
        padding: 0 10px;
        color: #fff;
        border: 1px solid #fff;
        background: transparent;
        border-radius: 3px;
      }
      button:hover{
        box-shadow: inset 37px 37px 3px rgba(0, 0, 0, 0.125);
      }
      .double {
        margin-right: 20px;
      }
    }
  }
  .content-box{
    position: relative;
    margin: 0 20px 20px;
    padding:  20px 20px 0;
    border: 1px solid #ddd;
    background: #fff;
    .doubleView{
      float: left;
      width: 49%;
    }
    .margin-right{
      margin-right: 2%;
    }
    .version0{
      // border: 1px solid #ddd;
      margin-bottom: 20px;
      box-sizing: border-box;
    }
    .version1{
      // border: 1px solid #ddd;
      box-sizing: border-box;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// saleCommissionSetting.vue?21f77f12